import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../../../theme';
import { FlightPointFragment } from '@websky/graphql';

interface Props {
	location: FlightPointFragment;
	showAirportModal?: boolean;
}

const Point: React.FC<Props> = ({ location, showAirportModal }) => {
	const { Point: css } = useTheme('DesktopFlightInfo');
	const { t } = useTranslation();

	return (
		<div className={css.point}>
			<span>{location.time.substr(0, 5)}</span>
			<span>{location.airport.iata}</span>

			{showAirportModal ? (
				<span className={css.link}>{location.airport.name}</span>
			) : (
				<span className={css.airportName}>{location.airport.name}</span>
			)}

			{location.terminal && (
				<span className={css.terminal}>
					• {t('DesktopFlightInfo:Terminal')} {location.terminal}
				</span>
			)}
		</div>
	);
};

export default Point;
